import { useEffect, useState } from "react"
import { useTranslation } from 'hooks/useTranslation'
import { useRouter } from "hooks/useRouter"
import { useAddToCart } from "features/ECommerce/hooks/useAddToCart"
import { isElementVisible } from "utils/dom"
import { Loader } from "features/components/Loader"
import { Layout } from "components/Layout"
import { Header } from "components/Header"
import { Reviews } from "features/Recipes/components/Reviews"
import { RecipeFooter } from "features/Recipes/components/RecipeFooter"
import { Footer } from "components/Footer"
import { EssentialsRoot, Spacer } from "./Essentials.styles"
import { Hero } from "./components/Hero"
import thumbnail from '../../../../../../public/assets/product/essentials-hero.webp'
import { Best } from "./components/Best"
import { CustomMealPlan } from "../FivePound/components/CustomMealPlan"
import { OurIngredients } from "./components/OurIngredients"
import { Recipes } from "features/Recipes/FrozenRecipeDetail/FrozenRecipeDetail"
import { ProductPageReviews } from 'fixtures/review'
import { useFetchProductDetail } from "features/ECommerce/api/queries/useFetchProductDetail"
import { Proteins } from "models/Pet"

export const Essentials = () => {

    const { t } = useTranslation()
    const { query } = useRouter()
    const router = useRouter()
    const addToCart = useAddToCart()
    const header = <Header />
  
    const { productId } = query as { productId: 'big-box' | 'classic-box' | 'small-box' }

    const { data: productDetail, status} = useFetchProductDetail(productId)


    const [isHidden, setIsHidden] = useState(true)

    const { julie, cristin, barbara } = ProductPageReviews

    const turkeyIngredients = Recipes.TURKEY.ingredients
    const beefIngredients = Recipes.BEEF.ingredients
    const lambIngredients = Recipes.LAMB.ingredients
  
    useEffect(() => {
      const _scrollListener = () => {
        setIsHidden(false)
  
        const isCTAVisible = isElementVisible('.product-cta')
        const isFooterVisible = isElementVisible('.footer')
  
        if (isCTAVisible || isFooterVisible) {
          setIsHidden(true)
        }
      }
      document.addEventListener('scroll', _scrollListener)
  
      return () => document.removeEventListener('scroll', _scrollListener)
    })
  
    if (status === 'loading' || status === 'idle' || status === 'error') return <Loader />
    
 return (
    <EssentialsRoot>
      <Layout hideCTA header={header}>
        <Hero product={productDetail} box={productId} onAdd={addToCart} thumbnail={thumbnail} />
        <Best />
        <Spacer />
        <OurIngredients background='tertiary-200' recipe={Proteins.BEEF} ingredients={beefIngredients} />
        <OurIngredients background='accent-white' recipe={Proteins.LAMB} ingredients={lambIngredients} />
        <OurIngredients background='tertiary-200' recipe={Proteins.TURKEY} ingredients={turkeyIngredients} />
        <Spacer />
        <CustomMealPlan />
        <Reviews icon={false} background="tertiary-200" reviews={[julie, cristin, barbara]}/>
        <RecipeFooter ctaLink='/meal-plan' cta={t('products:footer.cta1')} header={t('products:footer.title')}  />
        <Footer />
      </Layout>
    </EssentialsRoot>
 )
}